export default class CartAlreadyBookedError extends Error {
    orderId;
    constructor(orderId) {
        super(`Cart with order ID ${orderId} has been booked.`);
        this.orderId = orderId;
    }
}
